__turbopack_context__.v({
  "alignLeft": "Title-module__zyAjSq__alignLeft",
  "infoDescription": "Title-module__zyAjSq__infoDescription",
  "infoIncludesTitle": "Title-module__zyAjSq__infoIncludesTitle",
  "infoTitle": "Title-module__zyAjSq__infoTitle",
  "mainTitle": "Title-module__zyAjSq__mainTitle",
});
